import { useNotification } from '@/shared/ui'
import { useHttp, useTranslate } from '@/shared/lib'
import { useMutation, useQueryClient } from '@tanstack/vue-query'

export const useSendForm = () => {
  const { addError, addSuccess } = useNotification()
  const http = useHttp()
  const { trs } = useTranslate()
  const queryClient = useQueryClient()

  const mutation = useMutation({
    mutationFn: (data: any) => http.post('/schedules', data),
  })

  /* Отправка формы */
  const sendForm = async (data: any, valid: boolean) => {
    if (!valid) return

    try {
      await mutation.mutateAsync(data)

      addSuccess(trs('itf.schedules_created'))

      await queryClient.fetchQuery({
        queryKey: ['load_schedules_tree', data.group_object_list_id],
      })
    } catch (error: any) {
      addError(trs(error?.response?.data?.data?.msg || 'request.unknown_error'))
    }
  }

  return {
    ...mutation,

    sendForm,
  }
}
